import Vue from 'vue'
import Router from 'vue-router'

const HomeComponent = () => import('@/views/home/Home.vue')
const NotFoundComponent = () => import('@/views/404.vue')
const FondPasswordComponent = () => import('@/views/findpassword/FindPassword.vue')
const UserComponent = () => import('@/views/user/User.vue')

const GroupComponent = () => import('@/views/group/Group.vue')

const AuthorizeComponent = () => import('@/views/authorize/Authorize.vue')
const SearchPage = () => import('@/views/authorize/SearchPage.vue')
const AuthorizeSetting = () => import('@/views/authorize/AuthorizeSetting.vue')

const JobComponent = () => import('@/views/jobs/Job')
const AuditComponent = () => import('@/views/audit/Audit.vue')
const ConfigureComponent = () => import('@/views/configure/Configure.vue')
const RoleComponent = () => import('@/views/role/Role.vue')

const OrgDepartment = () => import('@/views/jobs/OrgDepartment.vue')
const GeneralJob = () => import('@/views/jobs/GeneralJob.vue')
const SearchAccount = () => import('@/views/jobs/SearchAccount.vue')
const SearchPages = () => import('@/views/jobs/SearchPages.vue')
const SearchSetting = () => import('@/views/jobs/SearchSetting.vue')
const JobCheck = () => import('@/views/jobs/JobCheck/JobCheck.vue')

const deptmbsdeptComponent = () => import('@/views/deptmbsdept/deptmbsdept.vue')


Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            component: HomeComponent,
            children: [
                {
                    path: '/user',
                    name: 'user',
                    component: UserComponent
                }, 
                {
                    path: '/container',
                    name: 'container',
                    component: GroupComponent,
                }, 
                {
                    path: '/authorize',
                    component: AuthorizeComponent,
                    children: [{
                        path: '/',
                        component: SearchPage
                    }, {
                        path: '/authorizes',
                        component: AuthorizeSetting
                    }]
                }, 
                {
                    path: '/job',
                    component: JobComponent,
                    redirect: '/job/department/check/menu',
                    children: [{
                        path: '/department/job/menu',
                        component: OrgDepartment
                    }, {
                        path: '/job/common',
                        component: GeneralJob
                    }, {
                        path: '/job/search',
                        component: SearchAccount,
                        children: [
                            {
                                path: '/',
                                component: SearchSetting
                            },
                        // {
                        //     path: '/',
                        //     component: SearchPages
                        // }, 
                        // {
                        //     path: '/job/search/searchSetting',
                        //     component: SearchSetting
                        // },
                        ]
                    }, {
                        path: '/job/department/check/menu',
                        component: JobCheck
                    }]
                }, 
                {
                    path: '/audit',
                    component: AuditComponent
                    }, 
                {
                    path: '/configure',
                    component: ConfigureComponent,
                    
                }, 
                {
                    path: '/deptmbsdept',
                    component: deptmbsdeptComponent
                }, 
                {
                    path: '/role',
                    component: RoleComponent
                }
            ]
        }, 
        {
            path: '/home',
            name: 'home',
            component: HomeComponent
        },
        {
            path: '/404',
            name: '',
            component: NotFoundComponent,
            hidden: true
        }, 
        {
            path: '/find',
            name: 'find',
            component: FondPasswordComponent
        }, 
        {
            path: '*',
            component: NotFoundComponent
        }
    ]
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js